import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
const { tumsAxios } = window['tums-components'].default.Utils.data;
@Component
export default class action extends Vue {
    // 重写tumsAxios.post，为了记录保存时间
    tumsAxiosPost(url:string, data:any, resolve:Function, reject:Function|null = null, config:Object|null = null) {
        // eslint-disable-next-line prefer-rest-params
        let func = (data:any, response:any) => {
            this.$store.commit('saveTime/setSaveTime', new Date().getTime());
            resolve(data, response);
        };
        tumsAxios.post(url, data, func, reject, config);
    };

    axiosPost(url:string, data:any, resolve:Function, reject:Function|null = null, config:any = null) {
        axios.post(url, data, config)
            .then((res:any) => { resolve(res); })
            .catch((err:any) => { if (reject) { reject(err); } });
    };
}
